export enum CheckBotInferenceStatus {
  CHECK_BOT_INFERENCE_DISABLED = 'check_bot_inference_disabled',
  WAITING = 'waiting',
  PENDING = 'pending',
  PROCESSING = 'processing',
  FAILED = 'failed',
  DATA_RECEIVED = 'data_received',
}
